import { FC, useEffect, useRef, useState } from "react";
import { PersonalDetailsForm } from "../../organisms/PersonalDetailsForm";
import { Wrapper, HeaderText, FormWrapper, HeaderWrapper } from "./elements";
import { Modal } from "../../organisms/Modal";
import { ChangePasswordModalBody } from "../../organisms/ChangePasswordModalBody";
import {
  REAUTHENTICATE_CHANGE_PASSWORD,
  CHANGE_PASSWORD,
} from "../../../redux/user/actionType";
import { Button } from "../../atoms/Button";
import { FormikProps } from 'formik';

type Props = {
  isLoading: boolean;
  validate: any;
  isUpdating?: boolean;
  details: any;
  onUpdatePassword: (values: any) => void;
  invalidOldPassword: any;
  onUpdateAccountDetails: any;
  dispatchClearSpecificRequest?: (
    request: string
  ) => { type: string; payload: { type: string } } | undefined;
};

const PersonalDetails: FC<Props> = ({
  isLoading,
  validate,
  details,
  onUpdatePassword,
  dispatchClearSpecificRequest,
  invalidOldPassword = null,
  onUpdateAccountDetails,
  isUpdating,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const formRef = useRef<FormikProps<any>>(null);

  const handleOnCancelModal = () => {
    if (dispatchClearSpecificRequest) {
      dispatchClearSpecificRequest(REAUTHENTICATE_CHANGE_PASSWORD);
      dispatchClearSpecificRequest(CHANGE_PASSWORD);
    }
    setShowModal(false);
  };

  const handleOnChangePasswordModal = () => {
    setShowModal(true);
  };

  const modalBody: JSX.Element = (
    <>
      <ChangePasswordModalBody
        onConfirm={onUpdatePassword}
        onCancel={handleOnCancelModal}
        isLoading={isLoading}
        validate={validate}
        invalidOldPassword={invalidOldPassword}
      />
    </>
  );

  const handleButtonClick = () => {
    if (isEditMode) {
      if (formRef.current && formRef.current.dirty) {
        formRef.current.handleSubmit();
      } else {
        setIsEditMode(false);
      }
    } else {
      setIsEditMode(true);
    }
  }

  const updateAccountDetails = async (data: any) => {
    // @ts-ignore
    const { password, ...rest } = data;
    await onUpdateAccountDetails({ email: rest?.email, name: rest?.fullName }, "basicDetails");
    setIsEditMode(false);
  }

  return (
    <>
      <Wrapper>
        <HeaderWrapper>
          <HeaderText>My Account</HeaderText>
          { details?.accessType === "Superadmin" && (
            <Button disabled={isUpdating} type="primary" onClick={handleButtonClick}>{isEditMode ? "Save" : "Edit"}</Button>
          )}
        </HeaderWrapper>
        <FormWrapper>
          <PersonalDetailsForm
            innerRef={formRef}
            onUpdateAccountDetails={updateAccountDetails}
            details={details}
            isEditMode={isEditMode}
            onClickChangePassword={handleOnChangePasswordModal}
          />
        </FormWrapper>
        {isEditMode && details?.accessType === "Superadmin" && (
          <span style={{ color: "#E15126", marginTop: '.3em', display: 'flex' }}>You will be automatically logged out when you change your details.</span>
        )}
      </Wrapper>
      <Modal
        destroyOnClose
        visible={showModal}
        onModalClose={handleOnCancelModal}
        title={"Change Password"}
        body={modalBody}
      />
    </>
  );
};

export default PersonalDetails;
